import { z } from "zod";

import { LocationData } from "../../../../models/LocationData";

const phoneNumberSchema = z.object({
  number: z.string().trim()
});

export const schema = z.object({
  primaryPhoneNumber: phoneNumberSchema,
  additionalPhoneNumbers: z.array(phoneNumberSchema)
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (data: LocationData): Schema => {
  // Extract primary and additional phone numbers from location data
  // phone_numbers is an object with structure: {primaryPhone: string, additionalPhones: string[]}
  const phoneNumbers = JSON.parse((data as any).phone_numbers);

  // If phone_numbers exists and is an object
  if (phoneNumbers) {
    return {
      primaryPhoneNumber: {
        number: phoneNumbers.primaryPhone || ""
      },
      additionalPhoneNumbers: (phoneNumbers.additionalPhones || []).map(
        (phone: string) => ({
          number: phone
        })
      )
    };
  }

  // Fallback for empty data
  return {
    primaryPhoneNumber: {
      number: ""
    },
    additionalPhoneNumbers: []
  };
};
